import {api} from "../app/SynappApi";
import {TAGS} from "../config/constants";
import {getProvidedTags, objectToQueryStrings} from "../utils/query-utils";

const timeSheetApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getTimeSheets: builder.query({
            query: (params) => `/api/services/app/TimeSheet/GetAll${objectToQueryStrings(params)}`,
            transformResponse: (response) => response.result,
            providesTags: result => result ? getProvidedTags(result.items, TAGS.TIME_SHEETS) : []
        }),
        getTimeSheet: builder.query({
            query: (id) => `api/services/app/TimeSheet/Get?id=${id}`,
            transformResponse: (response) => response.result,
            providesTags: (result, error, id) => [{type: TAGS.TIME_SHEETS, id}],
        }),
        getTimeSheetSelectItems: builder.query({
            query: (wantsFullyBilled) => `api/services/app/TimeSheet/GetAllSelectItems?isClient=${wantsFullyBilled || false}`,
            transformResponse: (response) => response.result.items,
            providesTags: result => getProvidedTags(result, TAGS.TIME_SHEET_LIST_ITEMS, true)
        }),
        createTimeSheet: builder.mutation({
            query: (body) => ({
                url: 'api/services/app/TimeSheet/Create',
                method: 'POST',
                body,
            }),
            invalidatesTags: [{type: TAGS.TIME_SHEETS, id: TAGS.DEFAULT}],
        }),
        updateTimeSheet: builder.mutation({
            query: (body) => ({
                url: 'api/services/app/TimeSheet/Update',
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, {id}) => [{type: TAGS.TIME_SHEETS, id}],
        }),
        deleteTimeSheet: builder.mutation({
            query(id) {
                return {
                    url: `api/services/app/TimeSheet/Delete?id=${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: (result, error, id) => [{type: TAGS.TIME_SHEETS, id}],
        }),
        getTimeSheetsByProjectAndUser: builder.query({
            query: ({projectId, userId}) => `api/services/app/TimeSheet/GetTimeSheetsByProjectAndUser?projectId=${projectId}&userId=${userId}`,
            transformResponse: (response) => response.result,
            providesTags: (result, error, {projectId, userId}) => [{type: TAGS.TIME_SHEETS, id: TAGS.DEFAULT}],
        }),
        writeOffTimeSheet: builder.mutation({
            query: (body) => ({
                url: 'api/services/app/TimeSheet/WriteOff',
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, {timeSheetId}) => [{type: TAGS.TIME_SHEETS, id: timeSheetId}, {type: TAGS.TIME_SHEETS, id: TAGS.DEFAULT}],
        })
    })
});

export const {
    useGetTimeSheetsQuery,
    useGetTimeSheetQuery,
    useGetTimeSheetSelectItemsQuery,
    useCreateTimeSheetMutation,
    useUpdateTimeSheetMutation,
    useDeleteTimeSheetMutation,
    useGetTimeSheetsByProjectAndUserQuery,
    useWriteOffTimeSheetMutation
} = timeSheetApi;
